const version = 'v1';

let basePath = ''; // base URL of the APIs
let trackerBasePath = ''; // base URL of tracker APIs
let taraChatBasePath = ''; // base URL of tara chat APIs
let aiCheckoutTrackingScriptPath = '';
let env: 'DEV' | 'STAGING' | 'LIVE';
let shopifyClientId = '';
export const BUGSNAG_API_KEY = '0c051d898b4c705d9f58d66045fc561e';
export const GOOGLE_OAUTH_CLIENT_ID =
  '418676847049-r3l0p7ocgq02k99md2kueai9qao9s9m2.apps.googleusercontent.com';
// '326264066299-u88mlse625044qvj0p2c1ql1ebedhltv.apps.googleusercontent.com'; // '326264066299-2kr1t9sv8ijvflqbrarhkhg2tmac8d0f.apps.googleusercontent.com';
export const FACEBOOK_OAUTH_CLIENT_ID = '575310141629092';
export const TIKTOK_OAUTH_CLIENT_ID = '7192683216828891137';
export const LINKEDIN_OAUTH_CLIENT_ID = '78o1yyv1z4l16k';
export const INTERCOM_APP_ID = 'ixig6rth';
export const shopifyAdminURL = 'https://admin.shopify.com';
if (
  window.location.href.split('/')[2].includes('ondigitalocean.app') ||
  window.location.href.split('/')[2].includes('tara-vc.adup.io')
) {
  basePath = 'https://centralapi-vc.adup.io/api';
  trackerBasePath = 'https://ai-tracker-dev.kodeia.com/api';
  taraChatBasePath = 'https://tara-chat-api-dev-docr.kodeia.com';
  aiCheckoutTrackingScriptPath =
    'https://static.adup.io/scripts/tara-ai-optimize-development/dist/TaraAIOptimize.js';
  env = 'DEV';
  shopifyClientId = 'ff78e6ae19ce6293959943d9b38dc939';
} else if (
  window.location.href.split('/')[2].includes('localhost') ||
  process.env.NODE_ENV === 'development' ||
  window.location.href.split('/')[2].includes('dev')
) {
  basePath = 'https://centralapi-dev.kodeia.com/api';
  trackerBasePath = 'https://ai-tracker-dev.kodeia.com/api';
  taraChatBasePath = 'https://tara-chat-api-dev-docr.kodeia.com';
  aiCheckoutTrackingScriptPath =
    'https://static.adup.io/scripts/tara-ai-optimize-development/dist/TaraAIOptimize.js';
  env = 'DEV';
  shopifyClientId = 'ff78e6ae19ce6293959943d9b38dc939';
} else if (window.location.href.split('/')[2].includes('staging')) {
  basePath = 'https://centralapi-staging.kodeia.com/api';
  trackerBasePath = 'https://ai-tracker-staging.kodeia.com/api';
  taraChatBasePath = 'https://tara-chat-api-staging-docr.adup.io';
  aiCheckoutTrackingScriptPath =
    'https://static.adup.io/scripts/tara-ai-optimize-staging/dist/TaraAIOptimize.js';
  env = 'STAGING';
  // shopifyClientId = 'c4747b1d6889e52234a06cf43b303633';
  shopifyClientId = '6bb17edf0e0c092e8020b6908d9d83e9';
} else {
  basePath = 'https://centralapi.adup.io/api';
  trackerBasePath = 'https://ai-tracker.adup.io/api';
  taraChatBasePath = 'https://tara-chat-api-docr.adup.io';
  aiCheckoutTrackingScriptPath =
    'https://static.adup.io/scripts/tara-ai-optimize/dist/TaraAIOptimize.js';
  env = 'LIVE';
  shopifyClientId = '6bb17edf0e0c092e8020b6908d9d83e9';
}

export const CACHE_BUSTER_EXECUTION_INTERVAL = 30 * 60 * 1000; //* 30 minutes
export const REDUX_STORE_RESYNC_INTERVAL = 24 * 60 * 60 * 1000; //* 24 hours
export const APP_ENV = env;
export const INTERCOM_ENABLED_ENVS = ['LIVE'];
export const CENTRAL_API_BASE_URL = `${basePath}/${version}/`;
export const CENTRAL_API_BASE_URL_V2 = `${basePath}/v2/`;
export const TRACKER_API_BASE_URL = `${trackerBasePath}/${version}/`;
export const TARA_CHAT_API_BASE_URL = `${taraChatBasePath}/`;
export const SHOPIFY_OAUTH_CLIENT_ID = shopifyClientId;

/* ----------AUTHENTICATION ENDPOINT----------- */
export const LOGIN_API = CENTRAL_API_BASE_URL + 'login';
export const LOGOUT_API = CENTRAL_API_BASE_URL + 'logout';
export const PROFILE_DELETE_API = CENTRAL_API_BASE_URL + 'users/delete';

export const REGISTRATION_API = (merchantSlug: string) => {
  return `${CENTRAL_API_BASE_URL}merchants/${merchantSlug}/sellers`;
};
export const PRE_USER_INVITATION_API = (invitationId: string) => {
  return `${CENTRAL_API_BASE_URL}pre-user-invitation/${invitationId}`;
};

export const USER_INFO_API = CENTRAL_API_BASE_URL + 'user-info';
export const USER_ROLE_API = CENTRAL_API_BASE_URL + 'user/role';

export const WEBAUTHN_LOGIN_API = CENTRAL_API_BASE_URL + 'webauthn/login';
export const WEBAUTHN_REGISTER_API = CENTRAL_API_BASE_URL + 'webauthn/register';

/* ----------INIT ENDPOINT----------- */
export const INIT_API = CENTRAL_API_BASE_URL + 'seller-init';

/* ----------SHOP ENDPOINT----------- */
export const SHOP_API = CENTRAL_API_BASE_URL + `shops`;
export const CREATE_SHOP_API = (sellerID: string) => {
  return `${CENTRAL_API_BASE_URL}sellers/${sellerID}/shops`;
};

/** DELETE a shop by slug (used in Agency onboarding) */
export const DELETE_SHOP_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}`;
};

/** Update shop brand (logo and color) - form-data */
export const UPDATE_SHOP_BRAND_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shop/update-brand/${shopSlug}`;
};

/** Get shop brand (logo URL and color) - expected from BE */
export const GET_SHOP_BRAND_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shop/get-brand/${shopSlug}`;
};

/* ----------SETTINGS ENDPOINT----------- */
export const GENERATE_AUTH_KEY_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/generate-auth-key`;
};
export const USER_SETTINGS_API = CENTRAL_API_BASE_URL + 'users/settings';

/* ----------SHIPPING ENDPOINT----------- */
export const SHIPPING_API = CENTRAL_API_BASE_URL + `shipping`;

/* ----------DISCOUNTS ENDPOINT----------- */
export const DISCOUNTS_TYPES_API = CENTRAL_API_BASE_URL + `discounts/types`;
export const DISCOUNTS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/discounts`;
};

/* ----------CONVENIENCE FEE ENDPOINT----------- */
export const CONVENIENCE_FEE_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}convenience-fee/${shopSlug}`;
};

/* ----------INTEGRATION ENDPOINT----------- */
export const GET_ALL_INTEGRATIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/integrations`;
};
export const GET_TRACKER_INTEGRATIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/integrations/tracker`;
};

/* ----------PRODUCT ENDPOINT----------- */
export const PRODUCT_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/products`;
};
export const PRODUCT_SYNC_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/sync`;
};

/* ----------ORDERS ENDPOINT----------- */
export const ORDERS_API = CENTRAL_API_BASE_URL + `orders`;

/* ----------CMS ENDPOINT----------- */
export const GET_ALL_CMS_SERVICES_API = CENTRAL_API_BASE_URL + `cms`;
export const CMS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/cms`;
};

/* ----------PSP ENDPOINT----------- */
export const GET_ALL_PSP_SERVICES_API =
  CENTRAL_API_BASE_URL + `payment-services`;
export const PSP_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/psp`;
};

/* ----------STATISTICS ENDPOINT----------- */
export const STATISTICS_BY_SHOP_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}statistics/shop/${shopSlug}`;
};

export const GRAPHS_API = (integrationKey: string) => {
  return `${TRACKER_API_BASE_URL}company/${integrationKey}/graphs`;
};

/* ----------HELP ENDPOINT----------- */
export const HELP_LINE_API = `${CENTRAL_API_BASE_URL}help-line`;

/* ----------AI_CHECKOUT_TRACKING_LINK----------- */
export const AI_CHECKOUT_TRACKING_LINK = (key: string) => {
  return `${aiCheckoutTrackingScriptPath}?trackingId=${key}`;
};

export const GET_ACCESS_TOKEN_BY_INTEGRATION_KEY_API = (apiKey: string) => {
  return `${CENTRAL_API_BASE_URL}ai-tracker/access-token/${apiKey}`;
};

export const DETECT_CMS_API = `${CENTRAL_API_BASE_URL}ai-tracker/detect-cms`;

/* ----------AI TRACKER BASIC CONFIGS ENDPOINT----------- */
export const AI_TRACKER_BASIC_CONFIGS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}ai-tracker/${shopSlug}/configure`;
};

export const ONBOARDING_INTEGRATION_ZOHO_API = (sellerID: string) => {
  return `${CENTRAL_API_BASE_URL}onboard-integration/zoho/${sellerID}`;
};

/* ----------AI TRACKER RECOMMENDATIONS ENDPOINT----------- */
export const RECOMMENDATIONS_API = `${TRACKER_API_BASE_URL}recommendations`;
export const MANUAL_RECOMMENDATIONS_API = `${TRACKER_API_BASE_URL}recommendations/manual`;
export const CHECK_CONNECTION_API = `${CENTRAL_API_BASE_URL}ai-tracker/check-connectivity`;

/* ----------CUSTOM EVENTS ENDPOINT----------- */
export const AI_CHECKOUT_CUSTOM_EVENTS_API = (apiKey: string) => {
  return `${CENTRAL_API_BASE_URL}integrations/${apiKey}/custom-events`;
};

/* ----------CUSTOM CSS ENDPOINT----------- */
export const AI_CHECKOUT_CUSTOM_CSS_API = (apiKey: string) => {
  return `${CENTRAL_API_BASE_URL}integrations/${apiKey}/custom-css`;
};

/* ----------SUBSCRIPTION ENDPOINT----------- */
export const GET_SUBSCRIPTION_API =
  CENTRAL_API_BASE_URL + `subscriptions/get-available-subscriptions`;
// export const MAKE_SUBSCRIPTION_API =
//   CENTRAL_API_BASE_URL + `subscriptions/make-subscription`;
export const MAKE_SUBSCRIPTION_API =
  CENTRAL_API_BASE_URL + `payments/make-subscription`;
export const CANCEL_SUBSCRIPTION_API =
  CENTRAL_API_BASE_URL + `payments/cancel-subscription`;
export const GET_SUBSCRIPTION_PAYMENT_STATUS_API = (id: string) => {
  return `${CENTRAL_API_BASE_URL}subscriptions/subscription-payment-status/${id}`;
};
export const MANAGE_SUBSCRIPTION_API = (subscription_id: string) => {
  return `${CENTRAL_API_BASE_URL}billing/${subscription_id}/manage`;
};
export const GET_TARA_SUBSCRIPTION_PACKAGES_API =
  CENTRAL_API_BASE_URL +
  `subscriptions/subscription-types/tara-ai-services/packages`;
export const SUBSCRIPTION_CANCEL_FLOW_OPTIONS_API = (
  subscription_id: string
) => {
  return `${CENTRAL_API_BASE_URL}subscription/cancel-flow/options?subscription_id=${subscription_id}`;
};
export const SUBSCRIPTION_CANCEL_FLOW_PROCESS_API =
  CENTRAL_API_BASE_URL + `subscription/cancel-flow/process`;
export const SUBSCRIPTION_CANCEL_FLOW_SURVEY_API =
  CENTRAL_API_BASE_URL + `subscription/survey`;

/* ----------FORGOT PASSWORD ENDPOINTS----------- */
export const FORGOT_PASSWORD_ENDPOINT =
  CENTRAL_API_BASE_URL + 'forget-password';
export const VERIFY_PASSWORD_OTP_ENDPOINT =
  CENTRAL_API_BASE_URL + 'password/verify-otp';
export const PASSWORD_CHANGE_ENDPOINT =
  CENTRAL_API_BASE_URL + 'password/change';

/* ----------SHOPIFY WRAPPER ENDPOINTS----------- */
export const SHOPIFY_AUTH_URL = (shopDomain: string, redirectURL: string) => {
  return `${shopDomain}/admin/oauth/authorize?client_id=${SHOPIFY_OAUTH_CLIENT_ID}&scope=write_script_tags,write_pixels&redirect_uri=${redirectURL}`;
};
export const SHOPIFY_AUTH_API = `${CENTRAL_API_BASE_URL}shopify/auth`;
export const SHOPIFY_INJECT_SCRIPT_API = `${CENTRAL_API_BASE_URL}shopify/inject-script`;

/* ----------GOOGLE ANALYTICS CUSTOM DIMENSIONS ENDPOINT----------- */
export const GOOGLE_ANALYTICS_CUSTOM_DIMENSIONS_CHECK_API = (
  shopSlug: string
) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/integrations/check-custom-dimensions`;
};
export const GOOGLE_ANALYTICS_CUSTOM_DIMENSIONS_INSERT_API = (
  shopSlug: string
) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/integrations/ga-custom-dimensions`;
};
/* ----------GOOGLE ANALYTICS OAUTH URL ENDPOINT----------- */
export const GOOGLE_ANALYTICS_OAUTH_URL_API = `${CENTRAL_API_BASE_URL}tara/mcp/oauth/url?mcp_slug=google_analytics`;

/* ----------TARA ENDPOINTS----------- */
export const TARA_CHAT_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}chat/${shopSlug}`;
};
export const TARA_SETTINGS_CUSTOM_KEY = `${CENTRAL_API_BASE_URL}tara/settings/custom-key`;
export const TARA_CAN_CHAT_API = `${CENTRAL_API_BASE_URL}tara/canchat`;
export const TARA_ERROR_LOGS_API = `${CENTRAL_API_BASE_URL}tara/error-trigger`;
export const TARA_CHAT_STREAM_API = TARA_CHAT_API_BASE_URL + 'chat/stream';
export const TARA_CHAT_FEEDBACK_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}chat/${shopSlug}/feedback`;
};
export const POST_MCP_REQUEST_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/mcp/request-integration`;
};
export const MCP_SERVERS_API = CENTRAL_API_BASE_URL + 'tara/mcp/index';
export const MCP_CREDENTIALS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/mcp/${shopSlug}/credentials`;
};
export const MCP_OAUTH_SAVE_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/mcp/${shopSlug}/oauth/save`;
};
export const TARA_CUSTOM_INSTRUCTIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/custom-instructions/${shopSlug}`;
};
export const TARA_CUSTOM_INSTRUCTIONS_SETTINGS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/custom-instructions/${shopSlug}/settings`;
};
export const TARA_NOTIFICATIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/shops/${shopSlug}/insights/available`;
};
export const TARA_NOTIFICATIONS_UPDATE_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/shops/${shopSlug}/insights`;
};
export const TARA_NOTIFICATIONS_UPDATE_ORDER_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/shops/${shopSlug}/insights/update-order`;
};
export const TARA_INSIGHT_PREFERENCES_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/shops/${shopSlug}/insight-preferences`;
};
export const INSIGHT_DELIVERY_OPTIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}tara/shops/${shopSlug}/delivery-options`;
};
export const TARA_NOTIFICATIONS_SETTINGS_BY_SHOP_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL}shops/${shopSlug}/tara/notifications/settings`;
};
export const USER_CHANNELS_API = (userID: string) => {
  return `${CENTRAL_API_BASE_URL}users/${userID}/channels`;
};
export const VERIFY_EMAIL_LINK_API = `${CENTRAL_API_BASE_URL}channels/verify-link`;
export const GET_TARA_SUBSCRIPTION_STATUS_API =
  CENTRAL_API_BASE_URL + `subscriptions/status`;

// GET all activated items for a shop (insights, prompts, graphs)
export const TARA_ALL_ACTIVATED_ITEMS_API = (shop_slug: string) =>
  `${CENTRAL_API_BASE_URL}tara/shops/${shop_slug}/insights/all-activated-items`;

// Update a custom graph's notification flag
export const TARA_CUSTOM_GRAPH_UPDATE_API = (
  shop_slug: string,
  graphId: string | number
) => `${CENTRAL_API_BASE_URL_V2}shops/${shop_slug}/custom-graphs/${graphId}`;

// Update a custom prompt's notification flag
export const TARA_CUSTOM_PROMPT_UPDATE_API = (
  shop_slug: string,
  promptId: string | number
) => `${CENTRAL_API_BASE_URL_V2}shops/${shop_slug}/custom-prompts/${promptId}`;

/* ----------EXTERNAL APIS ENDPOINTS----------- */
export const EXTERNAL_API = CENTRAL_API_BASE_URL + `external-apis`;

/* ----------PRESENTATIONS ENDPOINTS----------- */
export const PRESENTATIONS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/presentations`;
};
export const PRESENTATION_API = (shopSlug: string, presentationId: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/presentations/${presentationId}`;
};
export const REPORT_GRAPHS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/custom-graphs`;
};
export const REPORT_GRAPHS_ID_API = (shopSlug: string, graphId: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/custom-graphs/${graphId}`;
};
export const PRESENTATION_FREQUENCIES_API = `${CENTRAL_API_BASE_URL_V2}presentations/frequencies`;
export const PRESENTATIONS_ALL_SHORTCODES_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/presentations/all-shortcodes`;
};

/* ----------CUSTOM PROMPTS ENDPOINTS----------- */
export const CUSTOM_PROMPTS_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/custom-prompts`;
};
export const CUSTOM_PROMPT_API = (shopSlug: string, customPromptId: string) => {
  return `${CENTRAL_API_BASE_URL_V2}shops/${shopSlug}/custom-prompts/${customPromptId}`;
};
export const SAVE_CUSTOM_PROMPT_FROM_CHAT_API = `${CENTRAL_API_BASE_URL_V2}custom-prompts/save-from-chat`;
export const SAVE_GRAPH_PROMPT_FROM_CHAT_API = (shopSlug: string) => {
  return `${CENTRAL_API_BASE_URL_V2}${shopSlug}/custom-prompts/save-graph-from-chat`;
};

/* ----------ADUP API KEYS ENDPOINTS----------- */
export const ADUP_API_KEYS_API = (shopId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/adup/${shopId}`;
};
export const ADUP_API_KEY_GENERATE_API = (shopId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/adup/generate/${shopId}`;
};
export const ADUP_API_KEY_DELETE_API = (apiKeyId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/adup/${apiKeyId}`;
};

/* ----------EXTERNAL API KEYS ENDPOINTS----------- */
export const EXTERNAL_API_TYPES_API = `${CENTRAL_API_BASE_URL}integrations/types`;
export const EXTERNAL_API_KEYS_API = (shopId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/external/${shopId}`;
};
export const EXTERNAL_API_KEY_UPDATE_API = (apiKeyId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/external/${apiKeyId}`;
};
export const EXTERNAL_API_KEY_DELETE_API = (apiKeyId: string) => {
  return `${CENTRAL_API_BASE_URL}apis/external/${apiKeyId}`;
};

/* ----------PROMPT BUILDER----------- */
export const PROMPT_BUILDER_WEBHOOK_URL =
  'https://n8n.adup.io/webhook/7acd81f9-f993-437c-b89a-587b0746d684';

/* ----------ADUP AI OPTIMIZER CHROME EXTENSION----------- */
export const ADUP_AI_OPTIMIZER_CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/bjolkfedhmeejpeefcbmlcifmjeegpjf?utm_source=adup-tara-client';
